<template>
  <div class="twitter-post-preview-header">
    <div class="twitter-post-preview-header__name">{{ profile ? profile.name : 'Sample Account' }}</div>
    <div class="twitter-post-preview-header__account">{{ profile && profile.username ? profile.username : '@Snappy_kraken'}} &#8226; {{ date + ' days' }}</div>
    <span v-html="dots" class="twitter-post-preview-header__dots"></span>
  </div>
</template>

<script>
import MoreDotsSvg from '!!raw-loader!../../../../../../../../assets/images/builders/dots.svg';
import {extractSocialPostStepPieces} from '../../mixins/extractSocialPostStepPieces.mixin';

export default {
  mixins: [extractSocialPostStepPieces],
  props: {
    pieces: Array,
    date: Number,
    profile: Object,
  },
  data() {
    return {
      dots: MoreDotsSvg,
    };
  },
  computed: {
    today() {
      return moment(new Date()).format('MMM DD');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.twitter-post-preview-header {
  padding-right: 10px;
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  grid-template-rows: 1fr;
  gap: 5px;

  &__name {
    font-weight: 700;
    font-size: 15px;
  }
  &__account {
    font-size: 15px;
    color: $color-shuttle-grey;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  &__dots {
    align-self: flex-start;
    position: relative;
    top: -8px;
    right: 8px;
    transform: rotate(90deg) scale(2);
  }
}
</style>
